import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IItineraryRoute } from '../itinerary-route/itinerary-route';
import { IWayPoint } from '../itinenary-list/itinerary';
import * as L from 'leaflet';
import { delay } from 'rxjs/operators';


@Injectable()
export class MapSharedService {
  private renderItineraryOnMap = new BehaviorSubject(false);
  isGetMapDirections$ = this.renderItineraryOnMap.asObservable();

  private clearMapDirections = new BehaviorSubject(false);
  isClearMapDirections$ = this.clearMapDirections.asObservable();
  
  private itineraryDistanceTime = new Subject();
  getItineraryDistanceTime$ = this.itineraryDistanceTime.asObservable();
  
  private selectedItineraryItem = new Subject();
  getSelectedItineraryItem = this.selectedItineraryItem.asObservable();

  private itineraryRouteRender = new Subject();
  isItineraryRouteRender$ = this.itineraryRouteRender.asObservable();

  private removeItineraryRouteControl = new Subject();
  getRemoveItineraryRouteControl$ = this.removeItineraryRouteControl.asObservable();

  private optimiseItinerary = new Subject();
  isOptimiseItinerary$ = this.optimiseItinerary.asObservable();

  private entireIntinerary = new Subject();
  getEntireItinerary = this.entireIntinerary.asObservable();

  private isUturnEnabled = new Subject();
  getUturnItinerary = this.isUturnEnabled.asObservable();

  private delayisUturnEnabled = new Subject();
  getUturnItineraryDelay = this.delayisUturnEnabled.asObservable().pipe(delay(2000));


  changeGetMapDirections(isRender:boolean){
    this.renderItineraryOnMap.next(isRender);
  }
  changeClearMapDirections(clearMap:boolean){
    this.clearMapDirections.next(clearMap);
  }
  changeItineraryDistanceTime(distanceTimeData :any) {
    this.itineraryDistanceTime.next(distanceTimeData);
  }
  showSelectedItineraryItem(latLng:any){
    this.selectedItineraryItem.next(latLng);
  }
  compareItineraryRoute(route:IItineraryRoute){
    this.itineraryRouteRender.next(route);
  }
  removeItineraryRoute(route:IItineraryRoute){
    this.removeItineraryRouteControl.next(route);
  }
  initiateOptimiseItinerary(optimise:boolean){
    this.optimiseItinerary.next(optimise);
  }
  showAllWaypoint(isShow:boolean){
    this.entireIntinerary.next(isShow);
  }
  enableUTurnItinerary(isUturn:boolean){
    this.isUturnEnabled.next(isUturn);
  }
  enableUTurnItineraryDelay(arr :L.LatLng [] ){
    this.delayisUturnEnabled.next(arr);
  }
  /**
   * Helper function to extract only latitude and longitude
   * @param itineraryDetails
   */
  getLatLongList(itineraryDetails: IWayPoint[]): L.LatLng[] {
    try{
    return itineraryDetails.map((itinerary) => {
      return L.latLng(
        parseFloat(itinerary.latitude),
        parseFloat(itinerary.longitude)
      );
    });
  }
  
  catch(ex){

  }
}

  private saveStatusSubject = new BehaviorSubject<'Success' | 'Failed' | null>(null);
    saveStatus$ = this.saveStatusSubject.asObservable(); // Observable for status changes

  setSaveStatus(status: 'Success' | 'Failed' | null): void {
    this.saveStatusSubject.next(status); // Update the saveStatus
  }

  getSaveStatus(): 'Success' | 'Failed' | null {
    return this.saveStatusSubject.getValue(); // Get the current saveStatus value
  }
  
}
